import { AiGeneratingUI } from '../../AiGeneratingUI';
import { useAiGenerateSubjectiveStatusValue } from './useAiGeneateSubjectiveStatus';
export const AiGenerateAnswerListOverlay = () => {
  const {
    isGeneratingBulk
  } = useAiGenerateSubjectiveStatusValue();
  return <AiGeneratingUI.BulkOptions isVisible={isGeneratingBulk} data-sentry-element="unknown" data-sentry-component="AiGenerateAnswerListOverlay" data-sentry-source-file="AiGenerateAnswerListOverlay.tsx" />;
};